import styled from 'styled-components';
import PersonalAssist from '../../assets/onboarding/assist.svg';

const CustomerAssist = styled(PersonalAssist as React.SFC<React.SVGProps<SVGSVGElement>>)`

    width: ${props => props.width || '3.9rem'};
    height: ${props => props.height || '3.4rem'};
    display: flex;

    @media only screen and (min-width:1100px) and (max-width: 1300px){
        width: 4rem;
        height: 4rem;
    }
`;

export default CustomerAssist;
